/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Button, Grid} from '@scuf/common';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import FaultsList from './FaultsList'
import {Routes} from "../../utils/Routes";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";

class Faults extends React.Component {

    render() {
        const {intl, history} = this.props
        return (
            <div id="faults-list">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8} sWidth={12}>
                            <h2><FormattedMessage id="page.faults" /></h2>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <FaultsList />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

export default injectIntl(withRouter(connect(mapStateToProps)(Faults)))